import { store } from "../redux/store";

export const getToken = () => {
  const { auth } = store.getState();

  return auth.user.Token || localStorage.RAToken;
};
